export default {
    name: '',
    avatar: '',
    roles: [],
    createdAt: ''
}